<template>
  <div>
    <div class="row">
      <div class="col-md-3" v-for="(item, rowIndex) in data" :key="rowIndex">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-0" v-if="rowIndex === 0">Мероприятия</h4>
						<h4 class="card-title mb-0" v-if="rowIndex === 1">Программа семинара</h4>
          </div>
          <div class="drag-area bg-light">
						<draggable :disabled="!permissions.manage" tag="ul" :list="item" class="draggable list-group" handle=".handle" @end="onDraggableChange(rowIndex)">
							<li class="draggable__item" v-for="(item, itemIndex) in item" :key="itemIndex">
								<i class="fa fa-align-justify handle mr-3"></i>
								<label class="switch switch-xsm switch-3d switch-success mr-3">
									<input :disabled="!permissions.manage" class="switch-input" type="checkbox" :checked="item.status === 1" @change="onChangeStatus($event, rowIndex, itemIndex)">
									<span class="switch-slider"></span>
								</label>
								<button :disabled="!permissions.manage" class="btn btn-sm btn-light" type="button" v-if="item.repeat === 0" @click="onClickRepeat($event, rowIndex, itemIndex)"><i class="fa fa-repeat"></i></button>
								<button :disabled="!permissions.manage" class="btn btn-sm btn-primary" type="button" v-if="item.repeat === 1" @click="onClickRepeat($event, rowIndex, itemIndex)"><i class="fa fa-repeat"></i></button>
								<span class="text ml-3">{{ item.user.first_name }} {{ item.user.last_name }}</span>
								<i class="fa fa-circle fa-lg ml-auto text-success" v-if="item.last_at === item.updated_at"></i>
							</li>
						</draggable>
          </div>
        </div>
      </div>
    </div>
		<div class="toasty" :class="toasty ? 'show' : ''"><img src="/static/img/toasty.png" /></div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import orderQueueHTTP from '@/api/modules/order/queue/board'
export default {
	components: {
		draggable
	},
	data () {
		return {
			data: [],
			permissions: {
				manage: false
			},
			dragging: false,
			toasty: false
		}
	},
	created () {
		this.prepareBoard()
		this.$socket.on('order-queue-board', (data) => {
			this.prepareBoard()
		})
	},
	methods: {
		prepareBoard () {
			orderQueueHTTP.findAll().then((result) => {
				this.data = result.data
				this.permissions = result.permissions
			})
		},
		handlePlayToasty () {
			if (this.toasty === true) return false
			this.toasty = true
			let audio = new Audio('/static/audio/toasty.mp3')
			audio.play()
			setTimeout(() => {
				this.toasty = false
			}, 1300)
		},
		onDraggableChange (rowIndex) {
			orderQueueHTTP.update({data: this.data[rowIndex]}).then((result) => {
				this.$notify({
					group: 'success',
					type: 'success',
					title: 'Данные обновлёны'
				})
				this.handlePlayToasty()
			})
		},
		onChangeStatus (el, rowIndex, itemIndex) {
			this.data[rowIndex][itemIndex].status = el.target.checked === true ? 1 : 0
			orderQueueHTTP.update({data: this.data[rowIndex]}).then((result) => {
				this.$notify({
					group: 'success',
					type: 'success',
					title: 'Данные обновлёны'
				})
				this.handlePlayToasty()
			})
		},
		onClickRepeat (e, rowIndex, itemIndex) {
			this.data[rowIndex].forEach((value, _key) => {
				if (itemIndex === _key) return false
				value.repeat = 0
			})
			this.data[rowIndex][itemIndex].repeat = this.data[rowIndex][itemIndex].repeat === 0 ? 1 : 0
			orderQueueHTTP.update({data: this.data[rowIndex]}).then((result) => {
				this.$notify({
					group: 'success',
					type: 'success',
					title: 'Данные обновлёны'
				})
				this.handlePlayToasty()
			})
		}
	}
}
</script>
<style lang="scss">
@import "@/assets/scss/_variables.scss";
.drag-area {
	padding: 0.5rem;
	margin: 0.5rem;
	border-radius: 0.25rem;
	.draggable {
		li {
			display: flex;
			align-items: center;
			padding: 0.5rem;
			margin-bottom: 0.5rem;
			background: #fff;
			list-style: none;
			font-weight: bold;
			&:last-child {
				margin-bottom: 0;
			}
			.handle {
				cursor: move;
			}
			.switch {
				margin-bottom: 0;
			}
			.badge {
				padding: 0.25em 0.4em;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/order/board/index.vue